/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import {
  blue,
  brown,
  green,
  orange,
  purple,
  red,
  teal,
  yellow,
  grey,
} from "@mui/material/colors";

import { createMuiTheme, ThemeProvider } from "@mui/material/styles";

import { makeStyles, withStyles } from "@mui/styles";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PAuthenticationWindow from "../../components/pos/PAuthenticationWindow";
import { PrintUtils } from "../../utils/PrintUtils";
import { SaleUtils } from "../../utils/SaleUtils";
import { Store } from "../../utils/Store";
const useStyles = makeStyles({});

const theme = createMuiTheme({
  status: {
    danger: orange[500],
  },
});

const DigitButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "1rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
  },
}))(Button);

const ActionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.85rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: blue[500],
    "&:hover": {
      backgroundColor: blue[700],
    },
  },
}))(Button);

export default function RightActionPanel(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [customerId, setCustomerId] = useState("");

  var biRef = {};

  return (
    <ThemeProvider theme={theme}>
      <Grid container style={{ height: "100%" }}>
        <Grid item xs={12}>
          <Grid container style={{ height: "100%" }}>
            <Grid item xs={4} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={
                  props.saleType != "SALE" ||
                  !props.privileges.return_buttun_allowed
                }
                style={{
                  backgroundColor:
                    props.saleType === "SALE"
                      ? props.returnFlag
                        ? orange[500]
                        : blue[500]
                      : grey[500],
                }}
                onClick={() => {
                  props.changeReturnFlag(!props.returnFlag);
                }}
              >
                {translate("RETURN") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F1"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={!props.privileges.drawer_buttun_allowed}
                style={{
                  backgroundColor: blue[500],
                }}
                onClick={() => {
                  props.openDrawer();
                }}
              >
                {translate("DRAWER") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F2"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2, marginTop: 5 }}>
              <ActionButton
                disabled={!props.privileges.reprint_buttun_allowed}
                style={{
                  backgroundColor: blue[500],
                }}
                onClick={() => {
                  props.reprint();
                }}
              >
                {translate("REPRINT") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F3"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.hold_buttun_allowed}
                onClick={() => {
                  props.holdSale();
                }}
                style={{
                  backgroundColor: yellow[900],
                }}
              >
                {translate("HOLD") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F4"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.unhold_buttun_allowed}
                onClick={() => props.setShowUnHoldWindow(true)}
                style={{
                  backgroundColor: yellow[900],
                }}
              >
                {translate("UNHOLD") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F5"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.void_buttun_allowed}
                onClick={() => {
                  props.resetSale();
                }}
                style={{
                  backgroundColor: red[600],
                }}
              >
                {translate("VOID") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F6"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.History_buttun_allowed}
                onClick={() => props.handleShowHistoryClick()}
                style={{
                  backgroundColor: brown[600],
                }}
              >
                {translate("HISTORY") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F7"
                    : "")}
              </ActionButton>
            </Grid>{" "}
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.switch_button_allowed}
                onClick={() => props.setShowAuthScreen(true)}
                style={{
                  backgroundColor: teal[600],
                }}
              >
                {translate("SWITCH") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F8"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={4} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.remove_buttun_allowed}
                onClick={() => props.removeItem()}
                style={{
                  backgroundColor: red[600],
                }}
              >
                {translate("REMOVE") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F9"
                    : "")}
              </ActionButton>
            </Grid>
            <Grid item xs={12} style={{ padding: 2 }}>
              <ActionButton
                disabled={!props.privileges.customer_buttun_allowed}
                style={{
                  backgroundColor: orange[500],
                }}
                onClick={() => {
                  props.setShowCustomerLookupWindow(true);
                }}
              >
                {"Customer" +
                  (props.customerBean
                    ? "(" + props.customerBean.name + ")"
                    : "") +
                  (props.saleSetting && props.saleSetting.showKeyboardShortcuts
                    ? "-F10"
                    : "")}
              </ActionButton>
            </Grid>
            {props.saleType != "SERVICE" && (
              <Grid item xs={12} style={{ padding: 2 }}>
                <ActionButton
                  style={{ fontSize: "1.4rem", backgroundColor: green[700] }}
                  onClick={() => {
                    props.showPaymentWindow(true);
                  }}
                >
                  {(props.saleType == "SALE_ORDER"
                    ? translate("Place Order")
                    : translate("Payment")) +
                    (props.saleSetting &&
                    props.saleSetting.showKeyboardShortcuts
                      ? "-F11"
                      : "")}
                </ActionButton>
              </Grid>
            )}
            {props.saleType == "SERVICE" && (
              <Grid item xs={6} style={{ padding: 2 }}>
                <ActionButton
                  style={{ fontSize: "1.4rem", backgroundColor: green[700] }}
                  onClick={() => {
                    props.persistSale(false);
                  }}
                >
                  {translate("SAVE")}
                </ActionButton>
              </Grid>
            )}
            {props.saleType == "SERVICE" && (
              <Grid item xs={6} style={{ padding: 2 }}>
                <ActionButton
                  style={{ fontSize: "1.4rem", backgroundColor: green[700] }}
                  onClick={() => {
                    props.persistSale(true);
                  }}
                >
                  {translate("PRINT")}
                </ActionButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
